import { useDRResources } from './queries/drResourceQueries';

/**
 * DR 자원 데이터를 간결하게 사용하는 헬퍼 훅
 * @param {Object} params - 쿼리 파라미터
 * @returns {Object} DR 자원 데이터와 관련 정보
 */
export const useDRResourcesSimple = (params = {}) => {
  const { data: drResourcesData, isLoading, error } = useDRResources(params);
  
  const drResources = drResourcesData?.Items || [];
  
  return {
    drResources,
    isLoading,
    error,
    // 헬퍼 메서드들
    getDRResourceById: (id) => drResources.find(r => r.DrResourceSysId === id),
    getDRResourcesByType: (type) => drResources.filter(r => r.Type === type),
    totalCount: drResourcesData?.Total,
  };
};

export default useDRResourcesSimple;
